import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { back } from "../store/engine/engineReducer";
import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  button: {
    width: 192,
    height: 48,
    borderRadius: 0,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

export const BackButton: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClick = (): void => {
    dispatch(back(history));
  };
  return (
    <Button variant="outlined" className={classes.button} onClick={handleClick} data-test="Indietro">
      Indietro
    </Button>
  );
};
